import React, { useState, useEffect } from "react";
import {
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "reactstrap";

//i18n
import i18n from "../../../i18n";
import { withTranslation } from "react-i18next";

// falgs
import brazil from "../../../assets/images/flags/brazil.jpg";
import usFlag from "../../../assets/images/flags/us.jpg";

const LanguageDropdown = () => {
  const [menu, setMenu] = useState(false);
  const [lng, setLng] = useState("Portuguese");
  const [flag, setFlag] = useState(brazil);

  useEffect(() => {
    setLanguageState(i18n.language);
  }, []);

  const setLanguageState = (lng) => {
    if (lng === "pt-BR") {
      setLng((lng = "Portuguese"));
      setFlag(brazil);
    } else if (lng === "en-US") {
      setLng((lng = "English"));
      setFlag(usFlag);
    }
  };
  const changeLanguageAction = (lng) => {
    //set language as i18n
    i18n.changeLanguage(lng);

    setLanguageState(lng);
  };

  const toggle = () => {
    setMenu(!menu);
  };

  return (
    <React.Fragment>
      <Dropdown isOpen={menu} toggle={toggle} className="d-inline-block">
        <DropdownToggle className="btn header-item waves-effect" tag="button">
          <img src={flag} alt={flag} height="16" className="mr-1" />
          <span className="align-middle">{lng}</span>
        </DropdownToggle>
        <DropdownMenu className="language-switch" right>
          <DropdownItem
            tag="a"
            href="#"
            onClick={() => changeLanguageAction("pt-BR")}
            className="notify-item"
          >
            <img src={brazil} alt="Português" className="mr-1" height="12" />
            <span className="align-middle">Português</span>
          </DropdownItem>
          <DropdownItem
            tag="a"
            href="#"
            onClick={() => changeLanguageAction("en-US")}
            className="notify-item"
          >
            <img src={usFlag} alt="English" className="mr-1" height="12" />
            <span className="align-middle">English</span>
          </DropdownItem>
        </DropdownMenu>
      </Dropdown>
    </React.Fragment>
  );
};

export default withTranslation()(LanguageDropdown);
